export function Error({ message = '', shouldShow = false }) {
  if (!shouldShow) return null;

  return <span className="text-red-500 text-xs">{message}</span>;
}
